<template>
  <div class="wrapper d-flex flex-column">
    <!-- Navbar -->
    <nav class="navbar navbar-expand navbar-white navbar-light d-flex justify-content-between ml-0">
      <!-- Left navbar links -->

      <div class="brand-link">
        <img id="dashboard-logo"
             src="@/assets/images/logo_red.png"
             class="brand-image align-self-center" />
      </div>

      <ul class="nav nav-pills nav-sidebar flex-row align-self-end">
        <li class="nav-item"
            v-for="(menuItem, index) in menus"
            :key="index">
          <router-link :to="{ name: menuItem.pathName[0] }"
                       class="nav-link"
                       :class="{ active: markActive(menuItem) }">
            <i class="nav-icon"
               :class="menuItem.icon"></i>
            <p>{{ menuItem.title }}</p>
          </router-link>
        </li>
      </ul>

      <ul class="navbar-nav">
        <li class="nav-item">
          <div class="d-flex">
            <div class="dropdown user-dropdown mr-0 mt-2 mr-md-4 align-self-center">
              <div class="handler d-flex"
                   data-toggle="dropdown">
                <span class="text-color-4 align-self-center">Admin</span>
                <i class="fal fa-chevron-down text-color-4 align-self-center"></i>
              </div>

              <div class="dropdown-menu dropdown-menu-left text-color-2 --text-sm">
                <a class="dropdown-item text-color-2"
                   href="#"
                   @click="logout()">
                  <i class="fal fa-sign-out mr-1"></i>
                  {{ $t("general.logout") }}
                </a>
              </div>
            </div>
          </div>
        </li>

        <li class="nav-item"></li>
      </ul>
    </nav>
    <!-- /.navbar -->

    <!-- Content Wrapper. Contains page content -->
    <div class="container">
      <slot></slot>
    </div>
    <!-- /.content-wrapper -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { i18n } from "@/i18n";

export default {
  name: "Seller",
  components: {
  },
  data() {
    return {
      currentRoute: null,
      menus: null,
    };
  },

  created() {
    this.initNavbarMenu();
    this.setCurrentRoute(this.$route);
  },

  mounted() {
    if (localStorage.getItem("darkmode") && localStorage.getItem("darkmode") === "true") {
      this.toggleColorMode()
    }
  },

  destroyed() {
    clearInterval(this.timer);
  },

  methods: {
    toggleColorMode() {
      this.colorMode = !this.colorMode;
      if (document.body.classList.contains("--dark")) document.body.classList.remove("--dark")
      else document.body.classList.add("--dark")

      localStorage.setItem("darkmode", this.colorMode);
    },

    markActive(menuItem) {
      let includes = menuItem.pathName.includes(this.currentRoute);
      // if (includes) debugger;
      return includes;
    },

    initNavbarMenu() {
      // pathname can contain multiple values
      // routed to the 1st one only
      this.menus = [
        {
          title: "Users",
          icon: "fal fa-users",
          pathName: [
            "Users",
          ],
        }
      ];
    },

    logout() {
      this.$store.dispatch("user/logout", {
        callback: () => {
          clearInterval(this.timer);
          this.$router.push({ name: "Login" });
        },
      });
    },

    setCurrentRoute(route) {
      this.currentRoute = route.name;
    }
  },

  watch: {
    $route(to, from) {
      this.setCurrentRoute(to);
    },
  },
};
</script>

<style lang="scss">
.container {
  width: 100%;
  padding-right: var(--container-padding, 1rem);
  padding-left: var(--container-padding, 1rem);
  margin-right: auto;
  margin-left: auto;
  max-width: var(--container-max-width, 100%);
  padding-top: 2rem;
}

/* Define breakpoints similar to Tailwind's default settings */
@media (min-width: 640px) {
  :root {
    --container-max-width: 640px;
  }
}

@media (min-width: 768px) {
  :root {
    --container-max-width: 768px;
  }
}

@media (min-width: 1024px) {
  :root {
    --container-max-width: 1024px;
  }
}

@media (min-width: 1280px) {
  :root {
    --container-max-width: 1280px;
  }
}

.nav-icon {
  margin-right: 1.5rem !important;
}

.navbar {
  padding-bottom: 0 !important;
}

.nav-link {
  margin-bottom: 0 !important;
  margin-right: 1rem;
  border-bottom: 4px solid white;

  &.active {
    background: white !important;
    border-bottom: 4px solid red;
    color: inherit !important;
    border-radius: 0 !important;
  }
}

.nav-link.active {}

// ------------------Override styles-----------

.brand-link {
  position: relative !important;
  border-bottom: none;
  height: auto !important;

  .brand-image {
    margin-left: 0.4rem;
    max-height: 33px !important;
    border-radius: 100%;

    @include for-desktops-and-up {
      max-height: 59px;
    }

    transition: all 0.2s ease-in-out;
  }

  .brand-text {
    font-size: 1rem;
    line-height: 16px;
    color: red;
  }
}


.user-dropdown {
  cursor: pointer;

  img {
    width: 40px;
    height: 40px;
    margin-right: 8px;
  }

  span {
    margin-right: 8px;
  }

  .dropdown-menu {
    left: 50%;
    transform: translate(-50%);
  }
}

.navbar {
  box-shadow: none !important;
  border-bottom: 1px solid lightgrey;
}
</style>